import { PropTypes } from 'react-desc';
import { LEFT_ADDON_OPTIONS, RIGHT_ADDON_OPTIONS } from './options.js';

var inputProtectedProps = {
  leftAddon: PropTypes.oneOf([LEFT_ADDON_OPTIONS.LockLocked, LEFT_ADDON_OPTIONS.LockUnlocked]).description('left addon component to display'),
  rightAddon: PropTypes.oneOf([RIGHT_ADDON_OPTIONS.VisibleView, RIGHT_ADDON_OPTIONS.InvisibleHide]).description('right addon component to display').defaultValue(RIGHT_ADDON_OPTIONS.InvisibleHide),
  onChange: PropTypes.func.description('Function executed when input s value changes'),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).description('input s value'),
  readOnly: PropTypes.bool.description('Whether the input is read-only or not').defaultValue(false),
  mask: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.func]).description('mask to apply'),
  type: PropTypes.oneOf(['password', 'number', 'text']).description('type of input'),

  /**
   * PlaceholderChar: The placeholder character represents the fillable spot in the mask.
   * The default placeholder character is underscore, _.
   */
  placeholderChar: PropTypes.string.description("The placeholder character represents the fillable spot in the mask.\n  * The default placeholder character is underscore, _.")
};

export { inputProtectedProps };
//# sourceMappingURL=props.js.map
